import AdditionalInfo from "../../components/AdditionalInfo";
import Card from "../../components/Card";
import { Table } from "../../components/Compare/Table";
import CompareHeader from "../../components/CompareHeader";
import Page from "../../components/Page";
import { ProductType, FeatureType } from "../../data/symphony";

export const name = "Symphony";
export const path = "/symphony";
export const title = `Kaspersky ${name}`;

export const element = () => (
  <Page>
    <CompareHeader
      $title={
        <>
          Kaspersky <strong>{name}</strong>
        </>
      }
    >
      <p>
        Линейка решений, которая даёт организациям всё необходимое для
        постепенной или одночастной реализации системного подхода и построения
        надежной и адаптивной системы кибербезопасности. Все элементы экосистемы
        Symphony дополняют и усиливают друг друга. Выберите решение, которое
        лучше всего отвечает вашим задачам.
      </p>
    </CompareHeader>

    <Table
      products={Object.values(ProductType)}
      features={Object.values(FeatureType)}
    />

    <AdditionalInfo>
      <Card icon="browse" title="Обзор">
        <p>Изучите информацию об интересующем решении</p>
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://content.kaspersky-labs.com/se/media/ru/business-security/enterprise/kaspersky-symphony-datasheet.pdf"
            >
              Общий обзор
            </a>
          </li>
        </ul>
      </Card>
      <Card icon="compare" title="Сравнение">
        <p>Посмотрите сравнение и выберите оптимальное решение</p>
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://content.kaspersky-labs.com/se/media/ru/business-security/enterprise/kaspersky-symphony-datasheet.pdf"
            >
              Общий обзор
            </a>
          </li>
        </ul>
      </Card>
      <Card icon="goto" title="Страница решения">
        <p>Прейдите на страницу решений и получие больше информации</p>
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.kaspersky.ru/enterprise-security/symphony"
            >
              Перейти
            </a>
          </li>
        </ul>
      </Card>
    </AdditionalInfo>
  </Page>
);
